export default "__VITE_ASSET__yJO8LXRR__"